export default {
    namespaced: true,
    state: {
        drawerComponent: null,
        isDrawerOpen: false,
        drawerData: null
    },
    mutations: {
        openDrawer(state, { component, data = { isPersistent: true } }) {
            document.body.style.position = 'fixed';
            document.body.style.width = '100vw';
            state.drawerComponent = component;
            state.isDrawerOpen = true;
            state.drawerData = data;
        },
        closeDrawer(state) {
            document.body.style.position = null;
            document.body.style.width = null;
            state.drawerComponent = null;
            state.isDrawerOpen = false;
            state.drawerData = null;
        },
        setDrawerData(state, data) {
            state.drawerData = data;
        }
    }
}